import React, { useState, useEffect } from 'react';
import axios from 'axios';
import OrderCreate from '../components/OrderCreate';
//import OrderList from '../components/OrderList';
import OddsAgainstsUs from '../components/OddsAgainstUs';
import OrderUploadDownload from '../components/OrderUploadDownload';
import SubscriptionTab from '../components/SubscriptionTab';
import OrderListAssigned from "../components/OrderListAssigned"; // add this import
import OrderHistory from '../components/OrderHistory';

const OrdersManagement = () => {
  // General Tab States
 
  const [activeTab, setActiveTab] = useState('Tab1');
  const [callers, setCallers] = useState([]);
  const [selectedCaller, setSelectedCaller] = useState(''); // For callers/operators
  const [callTypes, setCallTypes] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [mobileNo, setMobileNo] = useState('');
  const [clientName, setClientName] = useState('');
  const [selectedCallType, setSelectedCallType] = useState('');

  // State for OrderCreate (Tab1)
  const [selectedOrder, setSelectedOrder] = useState(null);

  // Inline editing state for subscription table (Tab2)
  const [editingCustomerId, setEditingCustomerId] = useState(null);
  const [editingCustomerData, setEditingCustomerData] = useState(null);

  // Additional state for Subscription tab: radio selection and call type update panel
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);
  const [newCallType, setNewCallType] = useState('');

  // NEW: refreshSignal state to trigger OrderList updates
  const [refreshSignal, setRefreshSignal] = useState(0);
  const triggerRefresh = () => {
    setRefreshSignal(prev => prev + 1);
  };

  // Called on keydown in any editable input (inline editing for Subscription)
  const handleRowKeyDown = async (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      await updateEditingCustomer();
    }
  };

  const updateEditingCustomer = async () => {
    try {
      // Update the entire customer record (excluding call type, which is non-editable inline)
      const response = await axios.put(
        `https://astrovidhya.in/api/assigned-customers/${editingCustomerId}`,
        editingCustomerData
      );
      setCustomers((prev) =>
        prev.map((cust) =>
          cust._id === editingCustomerId ? response.data : cust
        )
      );
      // Clear inline editing state.
      setEditingCustomerId(null);
      setEditingCustomerData(null);
      // Trigger refresh (optional if the update response is already used to update local state)
      triggerRefresh();
    } catch (error) {
      console.error("Error updating customer:", error);
      alert("Failed to update customer. Please try again.");
    }
  };

  // Dedicated Update for Call Type (used by the panel below the table)
  const updateCallTypeForCustomer = async () => {
    if (!selectedCustomerId || !newCallType) {
      alert("Please select a customer (via radio button) and choose a new call type.");
      return;
    }
    try {
      const response = await axios.put(
        `https://astrovidhya.in/api/call-types/${selectedCustomerId}`,
        { callType: newCallType }
      );
      // Update local state with the updated customer
      setCustomers((prevCustomers) =>
        prevCustomers.map((cust) =>
          cust._id === selectedCustomerId ? response.data : cust
        )
      );
      alert("Call type updated successfully.");
      // Clear selection for panel
      setSelectedCustomerId(null);
      setNewCallType("");
      triggerRefresh();
    } catch (error) {
      console.error("Error updating call type:", error);
      alert("Failed to update call type. Please try again.");
    }
  };

  // Fetch callers/operators
  useEffect(() => {
    const fetchCallers = async () => {
      try {
        const response = await axios.get('https://astrovidhya.in/api/staff');
        const formattedCallers = response.data.map((caller) => ({
          _id: caller._id,
          username: caller.username,
        }));
        setCallers([{ _id: 'admin', username: 'All Members' }, ...formattedCallers]);
      } catch (error) {
        console.error('Error fetching callers:', error);
      }
    };

    fetchCallers();
  }, []);

  // Set default caller based on logged-in user
  useEffect(() => {
    const loggedInUser = localStorage.getItem('username'); // Assume this is stored during login
    setSelectedCaller(loggedInUser || 'All Members');
  }, []);

  // Fetch call types on component mount
  useEffect(() => {
    const fetchCallTypes = async () => {
      try {
        const response = await axios.get('https://astrovidhya.in/api/call-types');
        setCallTypes(response.data);
      } catch (error) {
        console.error('Error fetching call types:', error);
      }
    };

    fetchCallTypes();
  }, []);

  // Fetch customers based on filters
  const fetchCustomers = async () => {
    try {
      // Build the params object conditionally
      const params = {};
      if (selectedCallType && selectedCallType.trim() !== "") {
        params.callType = selectedCallType;
      }
      if (mobileNo && mobileNo.trim() !== "") {
        params.mobile = mobileNo;
      }
      if (clientName && clientName.trim() !== "") {
        params.name = clientName;
      }
      console.log("Sending params:", params); // Debug log

      const response = await axios.get(
        "https://astrovidhya.in/api/assigned-customers",
        { params }
      );
      setCustomers(response.data);
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="flex flex-col min-h-screen bg-gray-100 p-4 gap-4">
      {/* Tabs Navigation */}
      <div className="flex gap-4 mb-4">
        <button
          onClick={() => handleTabChange('Tab1')}
          className={`w-1/6 px-4 py-2 font-bold rounded-lg shadow-md ${activeTab === 'Tab1' ? 'bg-[#03C9D7] text-white' : 'bg-white text-gray-700'}`}
        >
          Order Management
        </button>
        <button
          onClick={() => handleTabChange('Tab2')}
          className={`w-1/6 px-4 py-2 font-bold rounded-lg shadow-md ${activeTab === 'Tab2' ? 'bg-[#03C9D7] text-white' : 'bg-white text-gray-700'}`}
        >
          Subscription
        </button>
     {/*   <button
  className={`px-4 py-2 rounded ${activeTab === 'Tab3' ? 'bg-blue-500 text-white' : 'bg-white text-gray-700'}`}
  onClick={() => setActiveTab('Tab3')}
>
  Assigned Orders from Admin
</button> */}

      </div>

      {/* Tab1: Order Management */}
      {activeTab === 'Tab1' && (
        <div className="flex flex-grow bg-gray-100 gap-4">
          {/* Left Section: OrderCreate and OrderUploadDownload */}
          <div className="w-1/3 h-1/2 flex flex-col gap-4">
            <div className="bg-gray-100 p-4 rounded-lg shadow-md flex-grow">
              <OrderCreate
                order={selectedOrder}
                onOrderAdded={() => {
                  setSelectedOrder(null);
                  triggerRefresh();
                }}
              />
            </div>
             {/* Only show UploadDownload if admin */}
           {/*    {localStorage.getItem('username') === 'admin' && (
            <div className="bg-white p-4 rounded-lg shadow-md">
                <OrderUploadDownload />
              </div>   
            )}   */}
          </div>
          {/* Right Section: OrderList and OddsAgainstsUs */}
          <div className="flex flex-col gap-4 h-screen w-2/3">
            <div className="bg-white p-4 rounded-lg shadow-md h-1/2 overflow-auto">
        {/*}    <OrderList
  refreshSignal={refreshSignal}
  onSelectOrder={(order) => setSelectedOrder(order)}
/> */}

<OrderHistory /> {/* ✅ replace with OrderHistory */}

            </div>
            <div className="bg-white p-4 rounded-lg shadow-md h-1/3 overflow-auto">
              <OddsAgainstsUs />
            </div>
          </div>
        </div>
      )}

{activeTab === 'Tab2' && (
  <SubscriptionTab />
)}


    </div>



  );

};




export default OrdersManagement;
